import {Component, inject, output} from '@angular/core';
import {UserSectionComponent} from "src/app/common/templates/header/user-section/user-section.component";
import {NotificationsV1Component as NotificationsComponent } from "src/app/common/templates/header/notifications-v1/notifications-v1.component";
import { AuthService } from 'src/app/services/Auth/auth.service';
import { RouterLink } from "@angular/router";

@Component({
  selector: 'common-header',
  imports: [
    UserSectionComponent,
    NotificationsComponent,
    RouterLink
],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  // injectables
  auth = inject(AuthService)

  // output
  showSidebar = output<void>();

  constructor() {}

}
